import { render, staticRenderFns } from "./SalaryEffectFloatBtns.vue?vue&type=template&id=9616e456&"
import script from "./SalaryEffectFloatBtns.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports